<template lang="pug">
div(:class='{ "w-full h-full": fitDiv }')
  iframe(
    onload='window.parent.scrollTo(0,0)'
    :src='url'
    frameborder='0'
    scrolling='no'
    allow='fullscreen; clipboard-write; geolocation'
    :class='[fitDiv ? "w-full h-full border-0" : "supports-[min-height:100dvh]:min-h-dvh min-h-screen w-screen border-0"]'
  )
</template>

<script setup lang="ts">
const fitmentStore = useFitmentStore()
const fitmentDisplayStore = useFitmentDisplayStore()

const { baseUrl, fitDiv = false } = defineProps<{
  baseUrl: string
  fitDiv?: boolean
}>()

const url = computed(() => {
  const url = baseUrl

  // The event.data.state string from Protex already contains fitment.
  // So if a hash exists in the url we can just return and early out, e.g. this is a 2025 Ford F-150
  // https://localhost:3000/builder/#H4sIAIAgy2cAA6WOMQvCMBCF/4rc4hK4ttIqHRXcXNykdojNKcXEk+Q6iPjfTQZFqODgdt/x8d5rGkDPLOhINKg7BLLUCRmoxQ+kYKPPBDWs2RuIxIZswrzMIu5I+0hFVpSRlmxukbZ0Gqz2k5U+pGeKgmo638Mk3Y9WvSp7IRewKvHdqY7aBhoZ+YeRVn0RXBqGfJWeLwEz7NiyR6eFfB8zMV/8nzH7NXQstE8cWNgOYAEAAA==
  if (import.meta.client && window?.location?.hash) return url + window.location.hash

  // We must have full fitment
  if (!fitmentDisplayStore.hasFullFitment) return url

  const urlObject = new URL(url)
  if (fitmentStore.makeSlug) urlObject.searchParams.set('make', fitmentStore.makeSlug)
  if (fitmentStore.modelSlug) urlObject.searchParams.set('model', fitmentStore.modelSlug)
  if (fitmentStore.year) urlObject.searchParams.set('year', fitmentStore.year)
  if (fitmentStore.bedSlug) urlObject.searchParams.set('bed', fitmentStore.bedSlug)
  if (fitmentStore.bodySlug) urlObject.searchParams.set('body', fitmentStore.bodySlug)

  // http://realtruck.oneprotex.com/builder/?make=ford&model=f150&year=2023&bed=6-7-bed&body=supercrew
  // http://realtruck.oneprotex.com/builder/?make=ford&model=f150&year=2023&bed=5-7-bed
  return urlObject.href
})

onMounted(() => {
  // Add an event listener from Protex
  window.addEventListener('message', handleProtexMessage)
})

onUnmounted(() => {
  window.removeEventListener('message', handleProtexMessage)
})

function handleProtexMessage(event) {
  if (event.origin !== baseUrl) return
  // If Protex has state update the url hash to the state string.
  if (event.data.state) window.location.hash = event.data.state
}
</script>
